import { useTranslation } from 'react-i18next';
import PicNewFeaturesAcademicYear from './img/pic-new-features-academic-year.png';
import PicNewFeaturesGlobalSearch from './img/pic-new-features-global-search.png';
import PicNewFeaturesNewBooking from './img/pic-new-features-new-booking.png';
import PicNewFeaturesTableHeader from './img/pic-new-features-table-header.png';

export function useReleaseHintReferences() {
  const { t } = useTranslation('release-hint');

  const config = [
    {
      releaseDate: '2021-02-20',
      url: '/',
      hints: [
        {
          pic: PicNewFeaturesGlobalSearch,
          name: 'global-search-bar',
          title: t('global_search_is_on_board'),
          description: t('global_search_is_on_board_description'),
        },
        {
          pic: PicNewFeaturesNewBooking,
          name: 'new-booking',
          title: t('quick_tip'),
          description: t('quick_tip_description'),
        },
      ],
    },
    {
      releaseDate: '2021-03-10',
      url: '/booking',
      hints: [
        {
          pic: PicNewFeaturesTableHeader,
          name: 'table-header-updated',
          title: t('table_header_updated'),
          description: t('table_header_updated_description'),
        },
      ],
    },
    {
      releaseDate: '2021-05-01',
      url: '/settings',
      hints: [
        {
          pic: PicNewFeaturesAcademicYear,
          name: 'academic-year-select',
          title: t('academic_year_expanded'),
          description: t('academic_year_expanded_description'),
        },
      ],
    },
  ];

  const latestReleaseHintConfig = config.sort(
    (a, b) => new Date(a.releaseDate) - new Date(b.releaseDate)
  )[config.length - 1];

  return latestReleaseHintConfig;
}
